define('views/shop/online/merchant',[
    'views/_base/baseview',
    'text!views/shop/online/merchant.html',
], function (BaseView, Template){
    'use strict';

    return BaseView.extend({
        tagName   : 'li',
        className : 'online-merchant',
        isRender  : true,
        template  : _.template(Template),
        events    : {
            'click .js-online-merchant-link': 'openAffiliateSite'
        },
        initialize: function(options){
            options = options || {};

            this.data = options.data.toJSON();

            // console.log('Online Merchant',this.data);

            BaseView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());

            return this;
        },

        openAffiliateSite: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            if(pf.session.get('auth')){

                saveAffiliateClick(this.data.GUID);
                window.open(this.data.AffiliateUrl);

            } else {
                
                // route to login and reroute once login complete
                var that = this;
                
                store.setStoreItem(enums.modelsEnum.AffiliateUrl, { Data: { AffiliateUrl: this.data.AffiliateUrl, MerchantName: this.data.Name } });

                pf.viewLogin(false, function(options){

                    store.getStoreItem(enums.modelsEnum.AffiliateUrl, null, false, false, false, function(data){                        
                        
                        ga('send', {
                            hitType: 'pageview',
                            page: options.MerchantName
                        });

                        saveAffiliateClick(options.GUID);

                        var string_url = options.AffiliateUrl;

                        if(string_url){

                            if(string_url.indexOf('userguid') >= 0){
                                var old_url = string_url.slice(0, string_url.indexOf('userguid')+9),
                                    new_url = old_url + pf.session.get('UserGUID');
                            } else {
                                var new_url = string_url;
                            }
                            
                            window.open(new_url);
                        } else {
                            console.warn('There is no affiliate url available.',string_url,that.data);
                        }

                    });

                }, { GUID: this.data.GUID, AffiliateUrl: this.data.AffiliateUrl, MerchantName: this.data.Name });
                
            }
        },

        close: function(){}
    });
});

